"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orientation = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.orientation = type_guard_1.props({
    horizontal: type_guard_1.optional(type_guard_1.enums(['left', 'center', 'right'])),
    vertical: type_guard_1.optional(type_guard_1.enums(['top', 'middle', 'bottom']))
});
